var $c88fa8b24ae60741$exports = {};
$c88fa8b24ae60741$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$c88fa8b24ae60741$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
